module.exports = __webpack_public_path__ + "img/sign-out-icon.f3d8f461.svg";